import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { formatMoney } from '../../../util/currency';
import { types as sdkTypes } from '../../../util/sdkLoader';
import { ExternalLink } from '../../../components';
import capitalize from 'lodash/capitalize';
import { ensureTransaction } from '../../../util/data';
import { BOND_FAIL_CAPTURED, BOND_FAIL_CREATED, propTypes } from '../../../util/types';
import { formatDate } from '../../../util/dates';
import { formatBondStatus } from '../../../util/transaction';

import css from './BondSection.css';

const { Money } = sdkTypes;

const BondSection = ({ transaction: tx }) => {
  const intl = useIntl();
  const transaction = ensureTransaction(tx);
  const { attributes, booking } = transaction;
  const { processName, protectedData = {}, metadata = {} } = attributes;
  const { bondFee } = protectedData;
  const { bondStatus, bondPaymentIntentId, bondCreatedAt, bondType, last4Digits } = metadata;

  return (
    <div className={css.bondSection}>
      <h2 className={css.sectionTitle}>
        <FormattedMessage id="AMTxPage.bondFee" defaultMessage="Bond" />
      </h2>
      <div className={css.sectionContent}>
        <div className={css.bondItem}>
          <div className={css.bondItemTitle}>
            <FormattedMessage id="AMTxPage.bondFee" defaultMessage="Bond fee" />
          </div>
          <div className={css.bondItemContent}>
            {bondFee ? formatMoney(intl, new Money(bondFee.amount, bondFee.currency)) : 'N/A'}
          </div>
        </div>
        <div className={css.bondItem}>
          <div className={css.bondItemTitle}>
            <FormattedMessage id="AMTxPage.bondStatus" defaultMessage="Bond status" />
          </div>
          <div className={css.bondItemContent}>{formatBondStatus(bondStatus || '') || 'N/A'}</div>
        </div>
        <div className={css.bondItem}>
          <div className={css.bondItemTitle}>
            <FormattedMessage id="AMTxPage.bondAction" defaultMessage="Bond actions" />
          </div>
          <div className={css.bondItemContent}>
            {bondStatus === BOND_FAIL_CREATED ? (
              <div className={css.bondAction}>
                <FormattedMessage
                  id="AMTxPage.bondAction.retryCreate"
                  defaultMessage="Retry create bond"
                />
              </div>
            ) : bondStatus === BOND_FAIL_CAPTURED ? (
              <div className={css.bondAction}>
                <FormattedMessage
                  id="AMTxPage.bondAction.retryCapture"
                  defaultMessage="Retry capture bond"
                />
              </div>
            ) : (
              <FormattedMessage id="AMTxPage.bondAction.NA" defaultMessage="N/A" />
            )}
          </div>
        </div>
        <div className={css.bondItem}>
          <div className={css.bondItemTitle}>
            <FormattedMessage id="AMTxPage.bondType" defaultMessage="Bond type" />
          </div>
          <div className={css.bondItemContent}>{capitalize(bondType) || 'N/A'}</div>
        </div>
        <div className={css.bondItem}>
          <div className={css.bondItemTitle}>
            <FormattedMessage id="AMTxPage.bondPaymentIntent" defaultMessage="Bond payment itent" />
          </div>
          <div className={css.bondItemContent}>
            <ExternalLink href={`https://dashboard.stripe.com/payments/${bondPaymentIntentId}`}>
              {bondPaymentIntentId || 'N/A'}
            </ExternalLink>
          </div>
        </div>
        <div className={css.bondItem}>
          <div className={css.bondItemTitle}>
            <FormattedMessage id="AMTxPage.cardLast4Digits" defaultMessage="Card last 4 digits" />
          </div>
          <div className={css.bondItemContent}>{last4Digits ? `...${last4Digits}` : 'N/A'}</div>
        </div>
        <div className={css.bondItem}>
          <div className={css.bondItemTitle}>
            <FormattedMessage id="AMTxPage.bondCreatedAt" defaultMessage="Created at" />
          </div>
          <div className={css.bondItemContent}>
            {bondCreatedAt ? formatDate(intl, 'Today', new Date(bondCreatedAt)) : 'N/A'}
          </div>
        </div>
      </div>
    </div>
  );
};

BondSection.propTypes = {
  transaction: propTypes.transaction,
};

export default BondSection;
